import { Component, inject, input, TemplateRef, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { Constants } from "../../../constants/constants";
import { Language } from "../../../constants/enums";
import { MonitoredKpiModelType, TableActionEvent } from "../../../models";
import { AppService } from "../../../services";
import { DataTableComponent } from "../../table/data-table/data-table";

@Component({
  selector: "adaa-metric-unlink-information",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./metric-unlink-information.html",
  styleUrl: "./metric-unlink-information.scss",
})
export class MetricUnlinkInformationComponent {
  private _router = inject(Router);
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);

  Constants = Constants;

  data = input.required<MonitoredKpiModelType[]>();
  title = input<string>("metrics.delete_yes_no_title");
  showMessage = input<boolean>(true);

  modal = viewChild.required<TemplateRef<unknown>>("content");

  public open() {
    this._modalService.open(this.modal(), {
      animation: true,
      scrollable: false,
      keyboard: false,
      size: "lg",
      centered: true,
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });
  }

  public actionClicked(event: TableActionEvent) {
    const url = Constants.ITEM_TYPE_ROUTES.find((e) => e.itemTypeId === event.data.kpiType);
    if (!url?.route) return;

    this._modalService.dismissAll();
    this._router.navigateByUrl(`${url.route}${event.data.id}`);
  }
}
